import { TMessage } from "@/i18n/tt";
import { MenuLinkProps } from "./MenuBar";

export type SideMenuGroupProps = { text: TMessage; items: MenuLinkProps[] };

export type SideMenuEntry = MenuLinkProps | SideMenuGroupProps;

export function isSideMenuGroup(entry: SideMenuEntry): entry is SideMenuGroupProps {
  return "items" in entry;
}

export function isSideMenuGroupExpanded(group: SideMenuGroupProps, toggled?: boolean): boolean {
  return toggled ?? group.items.some((item) => item.isActive);
}
